/**
 * GatesPanel — вердикт по 5 правилам методики (дизайн «Aikido Invest», ТЗ §3).
 * Презентационный слой: данные и логика gates с бэка не меняются.
 */

import type { EvaluateResponse } from "../api";
import { GATES, tip } from "../labels";
import { Tip } from "./Tooltip";

function verdictSummary(ev: EvaluateResponse): string {
  if (ev.accepted) return "Позиция проходит все правила методики — структурно её можно брать.";
  const g = ev.gates;
  if (g.no_loss && !g.no_loss.passed && !g.no_loss.skipped)
    return "Депозит не покрывает стоимость опционов — позиция может уйти в минус (нарушено «без зон убытка»).";
  if (g.premium_cap && !g.premium_cap.passed && !g.premium_cap.skipped)
    return "Премия дороже лимита 12% капитала — вход слишком дорогой.";
  if (g.iv && !g.iv.passed && !g.iv.skipped)
    return "Волатильность высокая (IV Rank > 40%) — опционы куплены дорого.";
  if (g.positive_expectancy && !g.positive_expectancy.passed && !g.positive_expectancy.skipped)
    return "Ожидаемый результат отрицательный — сборка структурно убыточна.";
  if (g.structural && !g.structural.passed)
    return "Конструкция неполная — нужны и Call, и Put (методика только покупает опционы).";
  return "Одно из правил методики не выполнено — детали ниже.";
}

export function GatesPanel({ evaluation }: { evaluation: EvaluateResponse }) {
  function gi(g: { passed: boolean; skipped?: boolean }) {
    if (g.skipped) return <span className="gi skip" title="Не проверено (нет данных)">○</span>;
    if (g.passed) return <span className="gi ok">✓</span>;
    return <span className="gi bad">⊘</span>;
  }
  return (
    <div className="card">
      <div className="card-h">
        <span>Проверка по 5 правилам методики <span style={{ color: "var(--txt-3)", fontWeight: 400, fontSize: 11 }}>5 gates</span></span>
        <span className={`vbadge ${evaluation.accepted ? "acc" : "rej"}`}>
          {evaluation.accepted ? "ПРИНЯТО" : "ОТКЛОНЕНО"}
        </span>
      </div>
      <div className="card-b">
        <div style={{ fontSize: 13, color: "var(--txt-2)", marginBottom: 6 }}>{verdictSummary(evaluation)}</div>
        <div>
          {Object.entries(evaluation.gates).map(([name, g]) => {
            const def = GATES[name];
            return (
              <div key={name} className="gate">
                {gi(g)}
                <div>
                  <div className="gt">
                    {def ? <Tip text={tip(def.t!)}>{def.primary}</Tip> : name}
                    {def && <span className="gtag">{def.secondary}</span>}
                    {g.skipped && <span className="gtag">○ не проверено</span>}
                  </div>
                  <div className="gd">{g.rationale}</div>
                </div>
              </div>
            );
          })}
        </div>
        {evaluation.rejection_reasons.length > 0 && (
          <div className="reasons">
            {evaluation.rejection_reasons.map((r, i) => <div key={i}>· {r}</div>)}
          </div>
        )}
      </div>
    </div>
  );
}
